export const environment = {
  production: false,

  // learningUrl: 'https://learning-dev.tsin.ca/',
  learningUrl: 'https://d2unppq4hwq1m9.cloudfront.net/',

  // userBaseUrl: 'https://user-dev-be.tsin.ca/api',
  userBaseUrl: 'https://zxkbbj3pcy.us-east-1.awsapprunner.com/api',
  userMgtUrl: 'http://user-dev.tsin.ca/auth/login',
  paymentUrl: 'https://payment-dev.tsin.ca',
  examOldUrl: 'https://portalstage.tsin.ca/',
  apiUrl: 'https://pikx4ijcua.us-east-1.awsapprunner.com/api',
  examUrl: 'https://portalstage.tsin.ca/',

  // paymentUrl: 'http://localhost:4400',
  examOldBaseUrl: 'https://portalstage-be.tsin.ca/api',
  learningBaseUrl: 'https://learning-dev-be.tsin.ca/api',

  userBaseUrlFallback: 'https://user-dev-be.tsin.ca/api',
  userBaseMgtUrlFallback: 'https://user-dev.tsin.ca/auth/login',

  salt: 'ZC\f?.Kp[jnhXf3-"<f3{/tZS@#~(8on',
  paymentMode: 'qa',
  paymentTimeLimitInMs: 180000,
};
